import { pdf } from '@react-pdf/renderer'
import React from 'react'
import { ProgrammeSummaryPDF } from '../pdf/ProgrammeSummaryPDF'
import { ClientData } from '../types/ClientData'

export async function downloadProgrammeSummary(data: ClientData): Promise<void> {
  const fileName = `${data.clientName?.replace(/\s+/g, '_') || 'Client'}_FFM_Summary_${new Date().toISOString().split('T')[0]}.pdf`

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const blob = await pdf(
    React.createElement(ProgrammeSummaryPDF, { data }) as any
  ).toBlob()

  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}
